/**
 * Judge.me Widget Override Script
 * Forces custom styling on Judge.me widgets after they load
 */

;(function () {
  'use strict'

  // Wait for Judge.me widget to load
  function overrideJudgemeStyles() {
    // Change "Customer Reviews" to "Reviews"
    const title = document.querySelector('.jdgm-rev-widg__title')
    if (title && title.textContent.trim() !== 'Reviews') {
      title.textContent = 'Reviews'
    }

    // Force blue star color on all stars
    const stars = document.querySelectorAll('.jdgm-star, svg.jdgm-star')
    stars.forEach((star) => {
      star.style.setProperty('color', '#00C0F3', 'important')
      star.style.setProperty('fill', '#00C0F3', 'important')
    })

    // Force horizontal layout for reviews
    const reviewsBody = document.querySelector('.jdgm-rev-widg__body')
    if (reviewsBody) {
      reviewsBody.style.setProperty('display', 'flex', 'important')
      reviewsBody.style.setProperty('flex-direction', 'row', 'important')
      reviewsBody.style.setProperty('overflow-x', 'auto', 'important')
      reviewsBody.style.setProperty('overflow-y', 'hidden', 'important')
      reviewsBody.style.setProperty('gap', '1.5rem', 'important')
      reviewsBody.style.setProperty('scroll-snap-type', 'x mandatory', 'important')
      reviewsBody.style.setProperty('flex-wrap', 'nowrap', 'important')
      reviewsBody.style.setProperty('padding-bottom', '2rem', 'important')
    }

    // Style individual review cards
    const reviews = document.querySelectorAll('.jdgm-rev')
    reviews.forEach((review) => {
      review.style.setProperty('min-width', '320px', 'important')
      review.style.setProperty('max-width', '320px', 'important')
      review.style.setProperty('width', '320px', 'important')
      review.style.setProperty('flex-shrink', '0', 'important')
      review.style.setProperty('scroll-snap-align', 'start', 'important')
      review.style.setProperty('background', 'white', 'important')
      review.style.setProperty('border-radius', '1rem', 'important')
      review.style.setProperty('padding', '1.5rem', 'important')
      review.style.setProperty('box-shadow', '0 1px 3px rgba(0, 0, 0, 0.1)', 'important')
      review.style.setProperty('display', 'flex', 'important')
      review.style.setProperty('flex-direction', 'column', 'important')
    })

    // Hide search box if present
    const searchBox = document.querySelector('.jdgm-search-box')
    if (searchBox) {
      searchBox.style.display = 'none'
    }

    // Hide pagination if present
    const pagination = document.querySelector('.jdgm-pagination')
    if (pagination) {
      pagination.style.display = 'none'
    }

    // Hide histogram
    const histogram = document.querySelector('.jdgm-histogram')
    if (histogram) {
      histogram.style.display = 'none'
    }

    // Hide summary wrapper
    const summaryWrapper = document.querySelector('.jdgm-rev-widg__summary-wrapper')
    if (summaryWrapper) {
      summaryWrapper.style.display = 'none'
    }
  }

  // Run on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      // Wait a bit for Judge.me to inject its content
      setTimeout(overrideJudgemeStyles, 500)
      setTimeout(overrideJudgemeStyles, 1000)
      setTimeout(overrideJudgemeStyles, 2000)
    })
  } else {
    setTimeout(overrideJudgemeStyles, 500)
    setTimeout(overrideJudgemeStyles, 1000)
    setTimeout(overrideJudgemeStyles, 2000)
  }

  // Also observe for dynamic changes
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.addedNodes.length) {
        overrideJudgemeStyles()
      }
    })
  })

  // Start observing when ready
  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    })
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      })
    })
  }
})()
